import React, { useEffect, useState, useContext, useRef } from 'react'
import {
  CCard,
  CButton,
  CFormSelect,
  CFormInput,
  //   CNav,
  //   CNavItem,
  //   CNavLink,
  CTabContent,
  CTabPane,
  CRow,
} from '@coreui/react'
import SearchTable from 'src/components/searchTable'
import moment from 'moment'
import useAxios from 'axios-hooks'
import { isEmpty } from 'lodash'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'bootstrap-daterangepicker/daterangepicker.css'
import { AppContext } from 'src/views/context/app'
import { ANALYTICS_API, DOBBY_ANALYTICS_API, USER_API } from 'src/views/utils/urls'
import { PAGE_SIZE } from 'src/views/utils/constants'
import { GlobalContext } from 'src/views/context/GlobalState'
import ImageNotFound from '../../../assets/image-not-found.jpg'
import { getThumbnail, convertDuration } from 'src/views/utils/helper'
import getSymbolFromCurrency from 'currency-symbol-map'

const PartnerAnalytics = () => {
  const dateRangeRef = useRef(null)
  const { setLoader, accountObj } = useContext(AppContext)
  const { userSessionObj, userObj } = useContext(GlobalContext)
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [deviceTypeFilter, setDeviceTypeFilter] = useState('')
  const [contentPartnerFilter, setContentPartnerFilter] = useState('')
  const [currencyFilter, setCurrencyFilter] = useState('')
  const [selectedCurrency, setSelectedCurrency] = useState('')
  const [currencyData, setCurrencyData] = useState([])

  const [contentPartnerMasterData, setContentPartnerMasterData] = useState([])
  const [page, setPage] = useState(1)
  const [partnerReportList, setPartnerReportList] = useState([])
  const [totalData, setTotalData] = useState({
    ppvShare: 0,
    subscriptionShare: 0,
    totalPayout: 0,
  })
  const isContentPartner = userObj?.user_type === 'CONTENT_PARTNER'

  const [{ data: contentPartnerList, loading: contentPartnerListLoading }, contentPartnerListCall] =
    useAxios(
      {
        url: `${USER_API}/content-partner`,
        method: 'get',
      },
      { manual: true },
    )

  const [{ data: partnerReportData, loading: partnerReportLoading }, partnerReportCall] = useAxios(
    {
      url: `${DOBBY_ANALYTICS_API}/content-partner-watch-report?page_size=${PAGE_SIZE}`,
      method: 'get',
    },
    { manual: true },
  )

  // const [
  //   { loading: downloadPartnerReportLoading, response: downloadPartnerResponse },
  //   downloadPartnerReportCall,
  // ] = useAxios(
  //   {
  //     url: `${DOBBY_ANALYTICS_API}/content-partner-watch-report/download`,
  //     method: 'get',
  //     responseType: 'arraybuffer',
  //   },
  //   { manual: true },
  // )

  const [{ data: partnerRevenueData, loading: partnerRevenueDataLoading }, partnerRevenueCall] =
    useAxios(
      {
        url: `${ANALYTICS_API}/content-partner-revenue-by-id`,
        method: 'get',
      },
      { manual: true },
    )

  useEffect(() => {
    setLoader(
      partnerReportLoading ||
        // downloadPartnerReportLoading ||
        contentPartnerListLoading ||
        partnerRevenueDataLoading,
    )
  }, [
    partnerReportLoading,
    // downloadPartnerReportLoading,
    contentPartnerListLoading,
    partnerRevenueDataLoading,
  ])

  useEffect(() => {
    if (partnerRevenueData && partnerRevenueData.success) {
      setSelectedCurrency(currencyFilter)
      let data = partnerRevenueData?.data
      setTotalData({
        ppvShare: Number(data.ppv_share).toFixed(2),
        subscriptionShare: Number(data.subscription_share).toFixed(2),
        totalPayout: Number(data.total_payout).toFixed(2),
      })
    }
  }, [partnerRevenueData])

  useEffect(() => {
    if (contentPartnerList && contentPartnerList.success && !isEmpty(contentPartnerList.data)) {
      setContentPartnerMasterData(contentPartnerList.data)
      setContentPartnerFilter(contentPartnerList?.data[0]?._id)

      partnerReportCall({
        params: {
          page: page,
          content_partner_id: contentPartnerList?.data[0]?._id,
        },
      })

      partnerRevenueCall({
        params: {
          currency: currencyFilter,
          content_partner_id: contentPartnerList?.data[0]?._id,
        },
      })
    }
  }, [contentPartnerList])

  useEffect(() => {
    if (!isEmpty(accountObj)) {
      setCurrencyFilter(accountObj?.allowed_countries[0]?.currency)
      setSelectedCurrency(accountObj?.allowed_countries[0]?.currency)
      setCurrencyData(accountObj?.allowed_countries)

      if (isContentPartner) {
        setContentPartnerFilter(userObj?._id)
        partnerReportCall({
          params: {
            page: page,
            content_partner_id: userObj?._id,
          },
        })
        partnerRevenueCall({
          params: {
            currency: accountObj?.allowed_countries[0]?.currency,
            content_partner_id: userObj?._id,
          },
        })
      } else {
        contentPartnerListCall()
      }
    }
  }, [accountObj])

  useEffect(() => {
    if (partnerReportData && partnerReportData.success) {
      page === 1
        ? setPartnerReportList(partnerReportData.data)
        : setPartnerReportList((contentReportList) => [
            ...contentReportList,
            ...partnerReportData.data,
          ])
    }
  }, [partnerReportData])

  // useEffect(() => {
  //   if (downloadPartnerResponse && downloadPartnerResponse.status === 200) {
  //     const blob = new Blob([downloadPartnerResponse.data], {
  //       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //     })
  //     const link = document.createElement('a')
  //     link.href = window.URL.createObjectURL(blob)
  //     link.download = `content-report.xlsx`
  //     link.click()
  //   }
  // }, [downloadPartnerResponse])

  const tableConfig = [
    {
      header: 'Thumbnail',
      dataCell: (info) => (
        <img
          className="card-img-top w-auto h-auto"
          src={getThumbnail(userSessionObj.session_data.cf_domain_name, info.thumbnail)}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null // prevents looping
            currentTarget.src = ImageNotFound
          }}
          alt={'content'}
          style={{ maxHeight: '5.2vw', maxWidth: '100%' }}
        />
      ),
      width: 12,
    },
    {
      header: 'Title',
      dataCell: (info) => info.title,
      width: 20,
    },
    {
      header: 'Content Type',
      dataCell: (info) => info.content_type,
      width: 12,
    },
    {
      header: 'Content ID',
      dataCell: (info) => info.content_id,
      width: 19,
    },
    {
      header: 'Total Watch Time',
      dataCell: (info) => convertDuration(info.total_watch_time),
      width: 12,
    },
    {
      header: 'Total Views',
      dataCell: (info) => info.total_views,
      width: 12,
    },
  ]

  const handleDateChange = (event, picker) => {
    picker.element.val(
      picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'),
    )
    setStartDate(moment.utc(picker.startDate).format('YYYY-MM-DDTHH:mm:ss'))
    setEndDate(moment.utc(picker.endDate).format('YYYY-MM-DDTHH:mm:ss'))
  }

  const handleCancel = (event, picker) => {
    picker.element.val('')
    setStartDate('')
    setEndDate('')
  }

  // const downloadExcel = () => {
  //   downloadPartnerReportCall({
  //     params: {
  //       start_date: startDate,
  //       end_date: endDate,
  //       device_type: deviceTypeFilter,
  //       content_partner_id: contentPartnerFilter,
  //     },
  //   })
  // }

  const applyFilter = () => {
    setPage(1)
    partnerReportCall({
      params: {
        page: 1,
        start_date: startDate,
        end_date: endDate,
        device_type: deviceTypeFilter,
        content_partner_id: contentPartnerFilter,
      },
    })
    partnerRevenueCall({
      params: {
        currency: currencyFilter,
        content_partner_id: contentPartnerFilter,
      },
    })
  }

  const resetFilters = () => {
    if (dateRangeRef.current) {
      dateRangeRef.current.$picker[0].value = ''
    }
    setPage(1)
    setStartDate('')
    setEndDate('')
    setDeviceTypeFilter('')
    setCurrencyFilter(currencyData[0]?.currency)
    partnerReportCall({
      params: {
        page: 1,
        content_partner_id: contentPartnerFilter,
      },
    })
    partnerRevenueCall({
      params: {
        currency: currencyData[0]?.currency,
        content_partner_id: contentPartnerFilter,
      },
    })
  }

  const handleNextPage = () => {
    partnerReportCall({
      params: {
        page: page + 1,
        start_date: startDate,
        end_date: endDate,
        device_type: deviceTypeFilter,
        content_partner_id: contentPartnerFilter,
      },
    })
    setPage((page) => page + 1)
  }

  return (
    <div className="">
      <h2>Partner Analytics</h2>
      <CRow className="mt-3">
        {/* <CNav variant="tabs">
        <CNavItem>
          <CNavLink
            className="px-5"
            style={activePane === 1 ? activeTab : inActiveTab}
            active={activePane === 1}
            onClick={() => setActivePane(1)}
          >
            {`Content Report`}
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink
            className="px-5"
            style={activePane === 2 ? activeTab : inActiveTab}
            active={activePane === 2}
            onClick={() => setActivePane(2)}
          >
            User Content Report
          </CNavLink>
        </CNavItem>
      </CNav> */}
        <CTabContent>
          <CTabPane role="tabpanel" visible={true}>
            <CRow>
              <CCard>
                <div className="d-flex justify-content-between mt-3 py-2">
                  <div className="d-flex">
                    <p className="mt-1">Filters:</p>
                    <div className="mx-2">
                      <CFormSelect
                        size="sm"
                        placeholder="Status"
                        value={deviceTypeFilter}
                        onChange={(e) => setDeviceTypeFilter(e.target.value)}
                      >
                        <option value="" selected disabled>
                          Device Type
                        </option>
                        <option value={'WEB'}>Web</option>
                        <option value={'MOBILE'}>Mobile</option>
                        <option value={'TABLET'}>Tablet</option>
                      </CFormSelect>
                    </div>
                    <div className="mx-2">
                      <CFormSelect
                        size="sm"
                        placeholder="Status"
                        value={currencyFilter}
                        onChange={(e) => setCurrencyFilter(e.target.value)}
                      >
                        <option value="" selected disabled>
                          Currency
                        </option>
                        {currencyData.map((info, index) => (
                          <option value={info.currency} key={index}>
                            {info.currency}
                          </option>
                        ))}
                      </CFormSelect>
                    </div>
                    <div className="mx-3">
                      <DateRangePicker
                        ref={dateRangeRef}
                        initialSettings={{
                          autoUpdateInput: false,
                          locale: { format: 'DD/MM/YYYY', cancelLabel: 'Clear' },
                          placeholder: 'Select Date Range',
                        }}
                        onApply={handleDateChange}
                        onCancel={handleCancel}
                      >
                        <CFormInput
                          size="sm"
                          type="text"
                          className=""
                          defaultValue=""
                          placeholder="Select Date Range"
                        />
                      </DateRangePicker>
                    </div>
                    {!isContentPartner && (
                      <div className="mx-3">
                        <CFormSelect
                          size="sm"
                          placeholder="Content Partner"
                          value={contentPartnerFilter}
                          onChange={(e) => setContentPartnerFilter(e.target.value)}
                        >
                          <option value="" disabled>
                            Content Partner
                          </option>
                          {!isEmpty(contentPartnerMasterData) &&
                            contentPartnerMasterData?.map((info, index) => (
                              <option value={info._id} key={index}>
                                {`${info.name} (${info.email_id})`}
                              </option>
                            ))}
                        </CFormSelect>
                      </div>
                    )}

                    <div className="mx-2">
                      <CButton color="info" size="sm" className="text-white" onClick={applyFilter}>
                        Apply
                      </CButton>
                    </div>
                    <p
                      className="mt-1"
                      style={{ color: '#1976d2', cursor: 'pointer' }}
                      onClick={resetFilters}
                    >
                      Reset Filter
                    </p>
                  </div>
                  {/* <div className="d-flex">
                    <div className="mx-2">
                      <CButton
                        color="success"
                        size="sm"
                        className="text-white"
                        onClick={downloadExcel}
                      >
                        Download Excel
                      </CButton>
                    </div>
                  </div> */}
                </div>
                <div className=" d-flex">
                  <div className="w-100 d-flex align-items-center">
                    <div
                      className="text-center font-weight-bold border py-1"
                      style={{ width: '17.3%', fontWeight: 'bold' }}
                    >
                      PPV Share :
                    </div>
                    <div className=" text-center border py-1" style={{ width: '16%' }}>
                      {`${totalData.ppvShare} ${
                        selectedCurrency ? getSymbolFromCurrency(selectedCurrency) : ''
                      }`}
                      {/* {`${totalData.ppvShare}`} */}
                    </div>
                    <div
                      className="font-weight-bold text-center border py-1"
                      style={{ width: '17.3%', fontWeight: 'bold' }}
                    >
                      Subscription Share :
                    </div>
                    <div className=" text-center border py-1" style={{ width: '16%' }}>
                      {`${totalData.subscriptionShare} ${
                        selectedCurrency ? getSymbolFromCurrency(selectedCurrency) : ''
                      }`}
                      {/* {`${totalData.subscriptionShare}`} */}
                    </div>
                    <div
                      className="font-weight-bold text-center border py-1"
                      style={{ width: '17.3%', fontWeight: 'bold' }}
                    >
                      Total Payout :
                    </div>
                    <div className=" text-center border py-1" style={{ width: '16%' }}>
                      {`${totalData.totalPayout} ${
                        selectedCurrency ? getSymbolFromCurrency(selectedCurrency) : ''
                      }`}
                      {/* {`${totalData.totalPayout}`} */}
                    </div>
                  </div>
                </div>
                <div style={{ zIndex: '0' }}>
                  <SearchTable
                    type={`Partner Analytics`}
                    tableCardHeight={65}
                    disableButton={true}
                    disableSearch={true}
                    marginDisable={true}
                    textAlign={'center'}
                    tableContent={partnerReportList}
                    tableConfig={tableConfig}
                    hashWidth={3}
                    handleNextPage={handleNextPage}
                    paginationEnable={
                      partnerReportData &&
                      !isEmpty(partnerReportData.data) &&
                      partnerReportData.total > page * PAGE_SIZE
                    }
                    totalTableContent={partnerReportData?.total}
                  />
                </div>
              </CCard>
            </CRow>
          </CTabPane>
        </CTabContent>
      </CRow>
    </div>
  )
}

export default PartnerAnalytics
